/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createOrder} from '../api'

export const useMutationCreateOrder = createReactQueryMutationHook('createOrder', createOrder)
